import PouchDB from "pouchdb";

import pouchAuth from "pouchdb-authentication";

import pouchUpsert from "pouchdb-upsert";

import pouchFind from "pouchdb-find";

const plugins = () => {
  PouchDB.plugin(pouchAuth);
  PouchDB.plugin(pouchUpsert);
  PouchDB.plugin(pouchFind);
  // PouchDB.debug.enable('pouchdb:find');
};

export default plugins;
